<template>
  <div style="width:100%;height:100%">
    <div ref="chart" style="width:100%;height:100%"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'yuyueCountTrendChart',
  props: {
    AppointmentInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      myChart: null,
      // 默认数据（根据设计稿示例）
      defaultData: {
        name: ['12-08', '12-09', '12-10', '12-11', '12-12', '12-13', '12-14', '12-15'],
        yuyueCount: [79, 63, 42, 37, 53, 49, 23, 19],
        qiandaoCount: [63, 58, 38, 36, 19, 19, 19, 19]
      }
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    AppointmentInfo: {
      handler(newVal) {
        if (this.myChart) {
          this.updateChart(newVal);
        }
      },
      deep: true
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chart) return;
      
      if (this.myChart) {
        this.myChart.dispose();
      }
      
      this.myChart = echarts.init(this.$refs.chart);
      this.updateChart(this.AppointmentInfo || this.defaultData);
    },
    
    updateChart(data) {
      if (!this.myChart) return;
      
      const name = data.name || this.defaultData.name;
      const yuyueCountData = data.yuyueCount || this.defaultData.yuyueCount;
      const qiandaoCountData = data.qiandaoCount || this.defaultData.qiandaoCount;
      
      // 计算最大值的120%（为了留出顶部空间）
      const allData = [...yuyueCountData, ...qiandaoCountData];
      const maxValue = Math.max(...allData);
      const yMax = Math.ceil(maxValue * 1.2);
      
      const option = {
         title: {
          left: 'center',
          top: 20,
          textStyle: {
            color: '#333',
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: 'rgba(50, 50, 50, 0.9)',
          borderColor: '#ccc',
          borderWidth: 1,
          textStyle: {
            color: '#fff'
          },
          formatter: function(params) {
            let result = `<div style="margin-bottom: 5px;">${params[0].axisValue}</div>`;
            params.forEach(item => {
              const color = item.color;
              const value = item.value;
              const seriesName = item.seriesName;
              result += `
                <div>
                  <span style="display:inline-block;margin-right:5px;width:10px;height:10px;background-color:${color};border-radius:2px;"></span>
                  <span>${seriesName}: ${value}</span>
                </div>
              `;
            });
            return result;
          }
        },
        legend: {
          data: ['预约人数', '签到人数'],
          top: 10,
          right: 10,
          textStyle: {
            color: '#666',
            fontSize: 12
          },
          itemWidth: 12,
          itemHeight: 12
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: name,
          axisLine: {
            lineStyle: {
              color: '#D6DDEB'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#464D5A',
            fontSize: 12
          }
        },
        yAxis: {
          type: 'value',
          name: '人数',
          nameTextStyle: {
            color: '#464D5A',
            fontSize: 12,
            padding: [0, 0, 0, -30]
          },
          axisLine: {
            lineStyle: {
              color: '#D6DDEB'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#464D5A',
            fontSize: 12,
          },
          splitLine: {
            lineStyle: {
              color: '#F0F2F5',
              type: 'dashed'
            }
          },
          max: yMax,
          interval: Math.ceil(yMax / 5),
          min: 0,
          minInterval: 1
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
            zoomLock: false // 允许缩放
          }
        ],
        series: [
          {
            name: '预约人数',
            type: 'bar',
            barWidth: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#297DEE' },
                { offset: 1, color: '#297DEE' }
              ]),
              borderRadius: [4, 4, 0, 0]
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#1A6BD4' },
                  { offset: 1, color: '#1A6BD4' }
                ])
              }
            },
            data: yuyueCountData
          },
          {
            name: '签到人数',
            type: 'bar',
            barWidth: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFB322' },
                { offset: 1, color: '#FFB322' }
              ]),
              borderRadius: [4, 4, 0, 0]
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#E69D1E' },
                  { offset: 1, color: '#E69D1E' }
                ])
              }
            },
            data: qiandaoCountData
          }
        ]
      };
      
      this.myChart.setOption(option);
      
      // 添加点击缩放功能（根据示例代码）
      const zoomSize = 3; // 每次点击显示3个柱子
      this.myChart.off('click'); // 移除之前的监听器
      this.myChart.on('click', (params) => {
        if (params.componentType === 'series' && params.seriesType === 'bar') {
          const dataIndex = params.dataIndex;
          const startIndex = Math.max(dataIndex - Math.floor(zoomSize / 2), 0);
          const endIndex = Math.min(startIndex + zoomSize - 1, name.length - 1);
          
          this.myChart.dispatchAction({
            type: 'dataZoom',
            startValue: name[startIndex],
            endValue: name[endIndex]
          });
        }
      });
    },
    
    handleResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    }
  }
}
</script>